import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import RedirectLink from './RedirectLink';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '23px',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',

    '& .MuiTypography-subtitle1': {
      lineHeight: '1.5',
    },
  },
  links: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',

    '& .MuiLink-root': {
      fontWeight: '400 !important',
    },
  },
});

const Footer = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Box className={classes.links}>
          <Typography variant="body1" className="highlighted">Institucional</Typography>

          <RedirectLink href="/quem-somos/">Quem somos</RedirectLink>
          <RedirectLink href="https://conube.com.br/blog/" toNewTab>Blog</RedirectLink>
          <RedirectLink href="https://atracaodetalentos.totvs.app/mindgroupvagas/extended" toNewTab>Trabalhe conosco</RedirectLink>
          {/* <RedirectLink href="/mapa-do-site/">Mapa do site</RedirectLink> */}
        </Box>

        <Box className={classes.links}>
          <Typography variant="body1" className="highlighted">Serviços</Typography>

          <RedirectLink href="/abrir-empresa/">Abrir empresa</RedirectLink>
          <RedirectLink href="/trocar-contador/">Trocar de contador</RedirectLink>
          <RedirectLink href="/quanto-custa/">Quanto custa?</RedirectLink>
        </Box>
      </Box>
      <Box className="address">
        <Typography variant="subtitle1" style={{ lineHeight: 1.51 }}>
          Endereço: Avenida Marques de São Vicente
          Nº 182 - Várzea da Barra Funda,  Sala 54
          São Paulo, SP - CEP 01139-000
        </Typography>
      </Box>

      {/* <Box className={classes.links}>
        <Typography variant="body1" className="highlighted">Segurança</Typography> */}

      {/* TODO: Colocar link do Registro no CRC */}
      {/* <RedirectLink href="/" toNewTab>Registro no CRC</RedirectLink> */}
      {/* TODO: Colocar link da Política de privacidade */}
      {/* <RedirectLink href="/" toNewTab>Política de privacidade</RedirectLink> */}
      {/* TODO: Colocar link dos Termos de uso */}
      {/* <RedirectLink href="/" toNewTab>Termos de uso</RedirectLink> */}
      {/* </Box> */}
    </Box>
  );
};

export default Footer;
